import { MeterData } from '@app/energiedaten/models/energiedaten.state';
import { MapStoreMunicipality } from '@app/shared/models/municipality/Municipality';
import { isNil, isEmpty } from 'lodash';
import { ZahlerstandMeterData } from '../models/zahlerstand.state';

export class MeterAddressFormatUtility {
  static getMeterAddress(value: ZahlerstandMeterData | MeterData, municipality?: MapStoreMunicipality, linebreak: boolean = true): string {
    if (isNil(value) || isEmpty(value)) {
      return '';
    }

    const street = value.street || '';
    const houseNumber = value.houseNumber || '';
    const zipCode = value.zipCode || '';
    const district = value.district || '';
    const municipalityName = municipality?.name;

    const addressLine1 = [street, houseNumber].filter(Boolean).join(' ');

    const addressLine2 = municipalityName ? `${zipCode} ${municipalityName}, ${district}` : `${zipCode} ${district}`;

    return linebreak ? `${addressLine1}\r\n${addressLine2}` : `${addressLine1} ${addressLine2}`;
  }
}
